/**
 * Pre-compiled es messages for FormActionBar
 * Generated by @internationalized/string-compiler
 * DO NOT EDIT MANUALLY
 */

export default {
  ariaLabel: `Form actions`,
  cancel: `Cancel`,
  delete: `Delete`,
  save: `Save`,
};
